import { useState, useEffect } from "react";
import { auth } from "../firebase";
import { signInAnonymously, onAuthStateChanged } from "firebase/auth";

export function useAuth() {
  const [user, setUser] = useState<import("firebase/auth").User | null>(null);
  const [authenticating, setAuthenticating] = useState(false);
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
    return () => unsub();
  }, []);

  const fetchWithAuth = async (url: string, init?: RequestInit, currentUser?: any) => {
    const userToUse = currentUser || user;
    const token = await userToUse?.getIdToken();
    console.log("🔐 fetchWithAuth - User:", userToUse?.uid, "Token length:", token?.length);
    console.log("🔐 fetchWithAuth - URL:", url);
    
    const headers = {
      "Content-Type": "application/json",
      ...(init?.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}`, "x-tenant-id": "blinkbli" } : {}),
    };
    
    console.log("🔐 fetchWithAuth - Headers:", Object.keys(headers));
    
    return fetch(url, {
      ...init,
      headers,
    });
  };

  const signInAnonymouslyUser = async () => {
    setAuthenticating(true);
    setAuthError(null);
    try {
      const userCredential = await signInAnonymously(auth);
      console.log("🔐 Anonymous user created:", userCredential.user.uid);
      return { success: true, user: userCredential.user };
    } catch (error: any) {
      console.error("Anonymous sign-in error:", error);
      const errorMessage = error?.message || "Anonymous sign-in failed";
      setAuthError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setAuthenticating(false);
    }
  };

  const ensureSignedIn = async () => {
    if (!user) {
      throw new Error("Please sign in first");
    }
  };

  return {
    user,
    authenticating,
    authError,
    signInAnonymouslyUser,
    ensureSignedIn,
    fetchWithAuth
  };
}